import { render } from "./teaSubBarEcharts.vue?vue&type=template&id=652c2bf0&scoped=true"
import script from "./teaSubBarEcharts.vue?vue&type=script&lang=js"
export * from "./teaSubBarEcharts.vue?vue&type=script&lang=js"

import "./teaSubBarEcharts.vue?vue&type=style&index=0&id=652c2bf0&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652c2bf0"]])

export default __exports__